import { FC } from 'react';
import { useTranslation } from '@nextgen-web-framework/all';
import { ProductCardComponent, CardType } from '../Molecules';
import { PLPHeaderCardPropsTypes } from './types/propsTypes';

export const PLPHeaderCard: FC<PLPHeaderCardPropsTypes> = ({
  link,
  alt,
  categoryName,
  resultsCount,
  categoryId,
  showZeroAsFree = false,
}: PLPHeaderCardPropsTypes): JSX.Element => {
  const t = useTranslation();

  return (
    <>
      <ProductCardComponent
        link={link}
        alt={alt}
        productId={categoryId || ''}
        brandName={categoryName}
        productName={`${t('product.plpHeader.results')} (${resultsCount})`}
        productSize=""
        derivedAvailabilityStatus=""
        cardType={CardType.PLPHEADER}
        showLinkForProductCard={false}
        showZeroAsFree={showZeroAsFree}
      />
    </>
  );
};

export type { PLPHeaderCardPropsTypes };
